import { createFileRoute } from '@tanstack/react-router';
import { FriendSettingsScreen } from '../features/friends/FriendSettings.tsx';

export const Route = createFileRoute('/settings_/friends')({ component: FriendSettingsScreen });
